export class Controller {

    $onChanges() {
        this.iconClass = ({
            'saaspass-cloud-directory': 'fa fa-database',
            AD: 'fa fa-server',
        })[this.directoryDto ? this.directoryDto.type || 'AD' : 'saaspass-cloud-directory'];
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-directory-label/sp-directory-label.controller.js